function setCookie(cookieName, cookieValue, expirationDays) {
	if (!cookieValue || !cookieName || !expirationDays) return;
	const expirationDate = new Date();
	expirationDate.setTime(expirationDate.getTime() + (expirationDays * 24 * 60 * 60 * 1000));
	const expires = `expires=${expirationDate.toUTCString()};`;

	const hostName = location.hostname;

	if (hostName.includes("chamaileon")) {
		document.cookie = `${cookieName}=${cookieValue};domain=chamaileon.io;path=/;${expires}SameSite=None; Secure`;
	} else {
		document.cookie = `${cookieName}=${cookieValue};domain=localhost;path=/;${expires}`;
	}
}

function getCookie(cookieName) {
	const value = `; ${document.cookie}`;
	const parts = value.split(`; ${cookieName}=`);
	if (parts.length === 2) return parts.pop().split(";").shift();
	else return undefined;
}

function removeCookie(cookieName) {
	const hostName = location.hostname;
	const domain = hostName.includes("chamaileon") ? "chamaileon.io" : location.hostname;

	document.cookie = `${cookieName}=; domain=${domain}; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
}

export default {
	setCookie,
	getCookie,
	removeCookie,
};
